import { orderBy as _orderBy } from 'lodash';

function sortByOrder(data, order) {
  var keys = order.map(function (rule) {
    return rule[0];
  });
  var orders = order.map(function (rule) {
    return rule[1];
  });
  return _orderBy(data, keys, orders);
}

export default {
  sortByOrder: sortByOrder
};